// extracted by mini-css-extract-plugin
export default {"songs-container":"Pages_songs-container__BkFI1","search-header":"Pages_search-header__zcVOi","search-wrapper":"Pages_search-wrapper__ToXKw"};